import { useTranslation } from 'react-i18next';

/**
 * A static, print-safe operator reference (plan Increment 11's own named deliverable): the
 * two-phase flow, the reschedule-versus-appointment-move distinction, and the out-of-window
 * rules. No interactive control, no participant-identifying content (CST-9.5) — safe to print or
 * share as-is. Reachable via a top-level nav entry (Resolution R10), not study-scoped.
 */
export function OperationalQuickReferencePage() {
  const { t } = useTranslation('clinical-study');
  return (
    <div className="max-w-3xl space-y-6">
      <h2 className="screen-title">{t('quickReference.title')}</h2>
      <p className="text-sm">{t('quickReference.intro')}</p>
      <section className="space-y-2">
        <h3 className="card-label">{t('quickReference.phaseOneTitle')}</h3>
        <p className="text-sm">{t('quickReference.phaseOneBody')}</p>
      </section>
      <section className="space-y-2">
        <h3 className="card-label">{t('quickReference.phaseTwoTitle')}</h3>
        <p className="text-sm">{t('quickReference.phaseTwoBody')}</p>
      </section>
      <section className="space-y-2">
        <h3 className="card-label">{t('quickReference.rescheduleVsMoveTitle')}</h3>
        <p className="text-sm">{t('quickReference.rescheduleVsMoveBody')}</p>
      </section>
      <section className="space-y-2">
        <h3 className="card-label">{t('quickReference.outOfWindowTitle')}</h3>
        <p className="text-sm">{t('quickReference.outOfWindowBody')}</p>
      </section>
    </div>
  );
}
